import { Box, Checkbox, FormControl, FormLabel, Input, Select, Textarea, VStack, Text, useToast } from "@chakra-ui/react";
import styled from "styled-components";
import { useState } from "react";

const ContactWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #333;  /* 어두운 배경 */
  color: #000;  /* 글씨 색상 검정으로 */
  padding: 20px;
`;

const BtnContact = styled.button`
  width: 100%;
  height: 60px;
  background: #444;  /* 어두운 버튼 배경 */
  color: #ffffff;  /* 흰색 텍스트 */
  font-size: 18px;
  border-radius: 62px;
  margin-bottom: 10px;
  &:hover {
    background: #666;  /* 호버 시 밝은 회색으로 변경 */
  }
`;

const Contact = () => {
    // 초기 상태 정의
    const initialFormData = {
      name: "",
      company: "",
      email: "",
      phone: "",
      inquiryType: "블랙박스 테스트", // 기본 선택값
      inquiryContent: "",
      agreeToPrivacy: false,
    };

  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.agreeToPrivacy) {
      toast({ title: "개인정보 수집에 동의해 주세요.", status: "warning" });
      return;
    }
    const response = await fetch("/db/processFormData", {
//     const response = await fetch("http://localhost:5001/processFormData", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData), // 폼 데이터
      });
      if (response.ok) {
        toast({ title: "문의가 성공적으로 제출되었습니다.", status: "info" });
        // 폼 초기화
        setFormData(initialFormData);
      } else {
        toast({ title: "문의 제출 중 오류가 발생했습니다.", status: "error" });
      }
  };

  const toast = useToast();

  return (
    <ContactWrapper>
      <Box maxW="600px" mx="auto" mt="8" p="6" borderWidth="1px" borderRadius="md" boxShadow="md" bg="white">
        <form onSubmit={handleSubmit}>
          <VStack spacing="4" align="stretch">
            <FormControl isRequired>
              <FormLabel color="#000">이름</FormLabel>
              <Input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="이름을 입력하세요"
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color="#000">회사명</FormLabel>
              <Input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="회사명을 입력하세요"
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color="#000">이메일</FormLabel>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="이메일 주소를 입력하세요"
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color="#000">휴대전화번호</FormLabel>
              <Input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // 숫자만 입력
                  setFormData({ ...formData, phone: value });
                }}
                placeholder="숫자만 입력하세요"
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color="#000">문의 유형</FormLabel>
              <Select
                name="inquiryType"
                value={formData.inquiryType}
                onChange={handleChange}
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
                _focus={{ borderColor: "#000" }}  /* 포커스 시 테두리 색상 설정 */
                    sx={{
                      "option": {
                        color: "#000", /* option 글자색을 검정색으로 설정 */
                      }
                  }}
              >
                <option value="블랙박스 테스트" selected>블랙박스 테스트</option>
                <option value="테스트 자동화">테스트 자동화</option>
                <option value="API 테스트">API 테스트</option>
                <option value="기타">기타</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel color="#000">문의 내용</FormLabel>
              <Textarea
                name="inquiryContent"
                value={formData.inquiryContent}
                onChange={handleChange}
                placeholder="문의 내용을 입력하세요"
                borderColor="#000"
                bg="#f5f5f5"  /* 배경색을 밝은 회색으로 설정 */
                color="#000"   /* 텍스트 색상을 검정색으로 설정 */
              />
            </FormControl>

            <FormControl>
              <Checkbox
                name="agreeToPrivacy"
                isChecked={formData.agreeToPrivacy}
                onChange={handleChange}
                colorScheme="teal"
                borderColor="black"
              >
                <Text color="#000" fontSize="sm">
                  개인정보 수집에 동의합니다.
                </Text>
              </Checkbox>
              <Text fontSize="sm" color="gray.600" mt="2">
                개인정보 수집 및 이용 목적은 사업문의와 관련한 정보를 제공하기 위해서입니다. 수집하는 개인정보 항목에서 이름, 회사명, 이메일, 휴대전화번호, 문의유형은 필수입니다. 개인정보 보유 및 이용기간은 사업문의와 관련한 작업이 마무리되는 시점까지 입니다. 귀하는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 다만, 필수항목의 수집 및 이용에 대해 동의하지 않을 경우에는 접수 및 처리가 제한됩니다.
              </Text>
            </FormControl>
            <BtnContact type="submit">
              문의하기
            </BtnContact>
          </VStack>
        </form>
      </Box>
    </ContactWrapper>
  );
};

export default Contact;
